export enum ParataNdcOrderType {
  Single = 'Single',
  Batch = 'Batch',
  All = 'All',
}
